import useTrackNewFeature from "../../actions/user/useTrackNewFeature";
import { UserPreferenceKey } from "../../../../common/api/decimal/methods/user.ts";
import useSampleSearchEligibility from "routes/home/search/layout/useSampleSearchEligibility.ts";

export default function useIsSampleSearchNew() {
  const { isSampleSearchEnabled } = useSampleSearchEligibility();

  return useTrackNewFeature({
    preferenceKey: UserPreferenceKey.SampleSearchLive,
    numDays: 30,
    isFeatureLive: isSampleSearchEnabled,
  });
}
